(function() {
    angular
        .module("alertsModule")
        .controller("AlertsController", AlertsController)

    AlertsController.$inject = [
        "$rootScope",
        "$scope",
        "alertsService"
    ]

    function AlertsController(
        $rootScope,
        $scope,
        alertsService
    ){
        "use strict"

        $rootScope.title = "Alerts | WANCO"

        $scope.alerts           = []
        $scope.forDisplay       = []
        $scope.selectedFixed    = []
        $scope.selectedNotFixed = []
        $scope.showType         = "NotFixed"
        $scope.searchText       = ""

        let allSelected      = false
        let markAnySuccess   = false

        $scope.insertSpacing = function(type) {
            // Insert space before internal capital letters
            return type.replace(/([A-Z])/g, " $1").replace(/  /g, " ").trim()
        }

        $scope.show = function(type) {
            $scope.showType = type
            getAlerts()
        }

        $scope.search = function(searchText) {

            clearChecked()
            $scope.searchText = searchText
            updateDisplayed()

        }

        $scope.uncheckSelectedAll = function() {

            angular.element(document).find(".alert-checkbox-all").prop("checked", false)
            allSelected = false

        }

        $scope.toggleCheckAll = function() {

            allSelected = !allSelected
            angular.element(document).find(".alert-checkbox").prop("checked", allSelected)
            $scope.refreshSelected()

        }

        $scope.refreshSelected = function() {

            $scope.selectedFixed    = []
            $scope.selectedNotFixed = []

            let allCheckboxes = angular.element(document).find(".alert-checkbox")
            let checkboxes = angular.element(document).find(".alert-checkbox:checked")

            if (allCheckboxes.length === checkboxes.length) {
                allSelected = true
                angular.element(document).find(".alert-checkbox-all").prop("checked", true)
            }

            for (const checkbox of checkboxes) {

                let alertID = $(checkbox).data("alert-id")

                if (alertID !== undefined) {

                    for (let i = 0; i < $scope.alerts.length; i++) {
                        let alert = $scope.alerts[i]
                        if (alert.id === alertID) {
                            if (alert.isFixed) {
                                $scope.selectedFixed.push(alert)
                            } else {
                                $scope.selectedNotFixed.push(alert)
                            }
                            break
                        }
                    }
                }
            }
        }

        $scope.markAsFixed = function() {

            markAnySuccess = false

            for (let i = 0; i < $scope.selectedNotFixed.length; i++) {

                let alert = $scope.selectedNotFixed[i]
                let last = i === $scope.selectedNotFixed.length - 1
                markAlert(alert, true, last)

            }
        }

        $scope.markAsNotFixed = function() {

            markAnySuccess = false

            for (let i = 0; i < $scope.selectedFixed.length; i++) {

                let alert = $scope.selectedFixed[i]
                let last = i === $scope.selectedFixed.length - 1
                markAlert(alert, false, last)

            }
        }

        let clearChecked = function() {

            $scope.uncheckSelectedAll()
            angular.element(document).find(".alert-checkbox").prop("checked", false)
            $scope.selectedFixed    = []
            $scope.selectedNotFixed = []

        }

        let markAlert = function(alert, fixed, last) {

            let comments = alert.comments !== undefined && alert.comments !== null ? alert.comments : ""

            let finish = function() {
                markAnySuccess = false
                alertsService.getAlertCount().then(function(data) {
                    $rootScope.alertCount = data.alerts
                })
                getAlerts()
            }

            let success = function() {
                markAnySuccess = true
                if (last) {
                    finish()
                }
            }

            let failure = function() {
                if (markAnySuccess && last) {
                    finish()
                }
                userMessagingService.error(error)
            }

            alertsService.updateAlert(alert.component_type, alert.component_id, alert.id, {fixed: fixed, comments: comments}).then(success, failure)

        }

        let updateDisplayed = function() {

            if ($scope.searchText === "") {

                $scope.forDisplay = []
                $scope.forDisplay = $scope.alerts

            } else {

                // Search applicable fields

                let search = $scope.searchText.toLowerCase()

                let displayAlerts = []

                for (const alert of $scope.alerts) {
                    if (alert.title.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if (alert.description !== undefined && alert.description !== null && alert.description.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if (alert.device_identity.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if (alert.isFixed && alert.fixed_by_username.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if ($scope.insertSpacing(alert.component_type).toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if (alert.created_at !== undefined && alert.created_at !== null && alert.created_at.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                    if (alert.comments !== undefined && alert.comments !== null && alert.comments.toLowerCase().includes(search)) {
                        displayAlerts.push(alert)
                        continue
                    }
                }

                $scope.forDisplay = []
                $scope.forDisplay = displayAlerts

            }
        }

        let getAlerts = function() {

            let success = function(data) {

                $scope.alerts = []
                $scope.alerts = data

                for (let alert of $scope.alerts) {
                    alert.isFixed = alert.fixed_by_username !== "" && alert.fixed_by_username !== null && alert.fixed_by_username !== undefined
                }

                clearChecked()
                updateDisplayed()

            }

            let failure = function() {
                $scope.alerts = []
                clearChecked()
                updateDisplayed()
            }

            alertsService.getAlerts($scope.showType).then(success, failure)

        }

        getAlerts()

    }
})()
